import { render, staticRenderFns } from "./NotificationApps.vue?vue&type=template&id=674e01fe&scoped=true"
import script from "./NotificationApps.vue?vue&type=script&lang=js"
export * from "./NotificationApps.vue?vue&type=script&lang=js"
import style0 from "./NotificationApps.vue?vue&type=style&index=0&id=674e01fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e01fe",
  null
  
)

export default component.exports